const dayjs = require("dayjs");
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

// Configura la zona horaria que necesitas, por ejemplo 'America/Mexico_City'
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(timezone);
dayjs.extend(utc);

// Configura la zona horaria que deseas utilizar
dayjs.tz.setDefault(process.env.VUE_APP_CURRENT_TIME_ZONE); // Reemplaza 'America/Mexico_City' con tu zona horaria

const dateTimeFormats = [
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DDTHH:mm:ssZ",
  "YYYY-MM-DDTHH:mm:ss.SSSZ",
  "YYYY-MM-DDTHH:mm:ss[Z]",
  "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
  "DD-MM-YYYY HH:mm:ss",
  "DD-MM-YYYY HH:mm",
  "DD/MM/YYYY HH:mm:ss",
  "DD/MM/YYYY HH:mm",
];

const parseDateTime = (value) => {
  if (!value) {
    return null;
  }

  const textValue = String(value).trim();

  if (!textValue) {
    return null;
  }

  for (const format of dateTimeFormats) {
    const parsed = dayjs(textValue, format, true);

    if (parsed.isValid()) {
      return parsed;
    }
  }

  const parsed = dayjs(textValue);

  return parsed.isValid() ? parsed : null;
};


//Retorna la hora en (00:00:00 AM-PM)
export const formatHours = (time) => dayjs(time, "HH:mm:ss").format("hh:mm:ss A");

//Retorna la fecha en (dia/mes/año)
export const formatDate = (date) => dayjs(date, "YYYY-MM-DD").format("DD-MM-YYYY");


//Retorna la fecha y hora en formato (dia/mes/año hora:minuto:segundo am-pm)
// export const formatDateTime = (dateTime) => dayjs(dateTime, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY hh:mm A");
export const formatDateTime = (dateTime) => parseDateTime(dateTime)?.format("DD-MM-YYYY hh:mm A") ?? "";
